import { render, staticRenderFns } from "./VacationCalendarComponent.vue?vue&type=template&id=63a6d8b7&scoped=true&"
import script from "./VacationCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./VacationCalendarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6d8b7",
  null
  
)

export default component.exports